import { httpRequest } from "../../http";
import { MediaFile } from "@models/mediaFile.model";

interface ListMediaParams {
    file_type?: string;
    extension?: string;
    exclude_extension?: string;
    name?: string;
    page?: number;
    page_size?: number;
    uploaded_by?: number;
}

export interface ListMediaResponse {
    results: MediaFile[];
    total: number;
    page: number;
    page_size: number;
}

export class CommandListMedia {
    async run(params: ListMediaParams = {}): Promise<ListMediaResponse> {
        const searchParams = new URLSearchParams();
        if (params.file_type) searchParams.set("file_type", params.file_type);
        if (params.extension) searchParams.set("extension", params.extension);
        if (params.exclude_extension) searchParams.set("exclude_extension", params.exclude_extension);
        if (params.name) searchParams.set("name", params.name);
        if (params.page) searchParams.set("page", String(params.page));
        if (params.page_size) searchParams.set("page_size", String(params.page_size));
        if (params.uploaded_by) searchParams.set("uploaded_by", String(params.uploaded_by));

        const query = searchParams.toString();
        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/media/${query ? `?${query}` : ""}`;

        const response = await httpRequest<ListMediaResponse>(url, { method: "GET" });
        response.results = response.results.map((r) => new MediaFile(r));
        return response;
    }
}
